(() => {
  const roots = [...document.querySelectorAll('[data-model-request-product]')];
  const successRoots = roots.filter((root) => {
    const success = root.querySelector('[data-model-request-success]');
    return success && !success.hidden;
  });
  const submittedFormId = window.location.hash.slice(1);
  const serverSuccessRoot = successRoots.find((root) => root.querySelector('form')?.id === submittedFormId) || successRoots[0];
  const challengeSuccessRoot = roots.find((root) => {
    const form = root.querySelector('form');
    return !serverSuccessRoot && form?.id === submittedFormId &&
      sessionStorage.getItem(`model_request_pending_${root.dataset.modelRequestProduct}`) === root.id;
  });
  const submittedRoot = serverSuccessRoot || challengeSuccessRoot;

  roots.forEach((root) => {
    if (root.dataset.modelRequestInitialized === 'true') return;
    root.dataset.modelRequestInitialized = 'true';
    const open = root.querySelector('[data-model-request-open]');
    const panel = root.querySelector('[data-model-request-panel]');
    const email = root.querySelector('input[type="email"]');
    const success = root.querySelector('[data-model-request-success]');
    const eventKey = `model_request_submitted_${root.dataset.modelRequestProduct}`;
    const pendingKey = `model_request_pending_${root.dataset.modelRequestProduct}`;
    const submittedSection = sessionStorage.getItem(pendingKey);
    const track = (name) => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, { product_id: root.dataset.modelRequestProduct });
        return true;
      }
      return false;
    };

    if (success && root === submittedRoot) {
      if (success.hidden) {
        [...root.querySelector('form').children].forEach((child) => {
          if (child !== success) child.hidden = true;
        });
        success.hidden = false;
      }
      panel.hidden = false;
      open.hidden = true;
      success.focus();
      if (sessionStorage.getItem(eventKey) !== 'sent') {
        const sendSubmitted = () => {
          if (sessionStorage.getItem(eventKey) === 'sent') return true;
          if (!track('model_request_submitted')) return false;
          sessionStorage.setItem(eventKey, 'sent');
          return true;
        };
        if (!sendSubmitted()) {
          let attempts = 0;
          const timer = setInterval(() => {
            attempts += 1;
            if (sendSubmitted() || attempts >= 120) clearInterval(timer);
          }, 250);
        }
      }
      sessionStorage.removeItem(pendingKey);
    }
    if (root.querySelector('[role="alert"]') && submittedSection === root.id) {
      panel.hidden = false;
      open.hidden = true;
      email?.focus();
      sessionStorage.removeItem(pendingKey);
    }
    open.addEventListener('click', () => {
      open.hidden = true;
      panel.hidden = false;
      sessionStorage.removeItem(eventKey);
      sessionStorage.removeItem(pendingKey);
      track('model_request_opened');
      email?.focus();
    });
    root.querySelector('button[type="submit"]')?.addEventListener('click', () => {
      if (root.querySelector('form').checkValidity()) {
        sessionStorage.setItem(pendingKey, root.id);
        sessionStorage.removeItem(eventKey);
      }
    });
    root.querySelector('form')?.addEventListener('submit', () => {
      sessionStorage.setItem(pendingKey, root.id);
      sessionStorage.removeItem(eventKey);
    });
  });
})();
